import {
    Component, OnInit, Input, Output, EventEmitter
} from '@angular/core';
import { DOData, DocdefDataVM, NJDocData, NJDocDefTemplate, NJReadDocDefTemplateLookup } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
@Component({
    selector: 'cy-grid-nradiobutton',
    templateUrl: './grid-nradiobutton.component.html',
    styleUrls: ['./grid-nradiobutton.component.css']
})
export class GridNRadioButtonComponent implements OnInit {
    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup>
    @Input() customParameters: any
    @Input() public ignorLabel: boolean = false;
    @Input() DocData: NJDocData
    @Input() LookupId: string;
    @Input() public loaderKey: string;
    @Input() isValid: boolean;
    @Input() isEnabled: boolean;
    @Input() hasEvent: boolean = false;
    @Input() skipPostDocDefData: boolean;
    errorMessage: string;
    oldDataValue: string;
    LabelStylesText: any
    HeaderStylesText: any;
    HeaderClass: string;
    @Output() clickRadio: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    private chkSelected: Array<any> = [];
    public test: Array<NJReadDocDefTemplateLookup> = [];
    public isDirty: boolean = false

    constructor(private data: DocDefPrimLibService) { }

    ngOnInit() {
        if (this.customParameters.hasEvent) {
            this.hasEvent = true;
        }
        if (this.customParameters['LabelStylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['LabelStylesText'], "'", '"');
            this.LabelStylesText = JSON.parse(styles);
        }
        if (this.customParameters['HeaderStylesText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['HeaderStylesText'], "'", '"');
            this.HeaderStylesText = JSON.parse(styles);
        }
        if (this.DocData.dataValue == "" || this.DocData.dataValue == null) {
            for (let item of this.lstDocDefTemplateLookup) {
                if (item.longDesc == this.customParameters['default']) {
                    this.DocData.dataValue = item.lookupId.toString();
                }
            }
        }
        this.onDoRadioClick();
    }
    IsSelected(templateID: number): boolean {
        let ret: boolean = false;
        if (this.DocData.dataValue == templateID.toString()) {
            ret = true;
        }
        return ret;
    }
    onBlurRadioButton() {
        this.doSave();
    }

    doSave() {
        if (!this.ignorLabel) {
            let lstDocData: DocdefDataVM = new DocdefDataVM();
            lstDocData.docdata.length = 0;
            lstDocData.docdata.push(this.DocData);
            lstDocData.loaderKey = this.loaderKey;
            var _this = this;
            this.isDirty = true;
            if ((this.customParameters.skipPostDocDefData == "True" || this.skipPostDocDefData == true) && this.customParameters.DontskipPostDocDefData != "True") {
                //return this.onSaveComplete();
                return this.onDoRadioClick();
            }
            else {
                this.data.saveDocDefData(lstDocData)
                    .subscribe(function () {
                        return _this.onDoRadioClick();
                    }, function (error) {
                        return _this.errorMessage = error;
                    });
            }
        }
    }

    onSaveComplete = function () {
        console.log(this.data.postResp);
        
    }
    Class() {
        let dict = this.customParameters;
        if (dict['Class'] == null) {
            return ""
        } else {
            return dict['Class'];
        }
    }
    getHeaderClass(): string {
        if (this.customParameters['HeaderClass'] == null) {
            return "form-inline";    
        } else {
            return this.customParameters['HeaderClass'];
        }
    }
    getHeaderTextClass(): string {
        if (this.customParameters['HeaderTextClass'] == null) {
            return "";
        } else {
            return this.customParameters['HeaderTextClass'];
        }
    }
    getButonsClass(): string {
        if (this.customParameters['ButtonsClass'] == null) {
            return "form-inline";
        } else {
            return this.customParameters['ButtonsClass'];
        }
    }
    getTextStyle(): object {
        if (this.customParameters['LabelStyleText'] != null) {
            let styles = this.data.replaceAll(this.customParameters['LabelStyleText'], "'", '"');
            this.LabelStylesText = JSON.parse(styles);
            if (this.isValid)

                return this.LabelStylesText;
            else
                this.LabelStylesText['background-color'] = "lightpink";
            return this.LabelStylesText;
        }
        else {
            if (this.isValid)
                return null
            else
                return { "background-color": "lightpink" };
        }
    }
    selectRadio(event, val: number) {
        this.oldDataValue = this.DocData.dataValue;
        this.DocData.dataValue = val.toString();

        this.doSave();
        
        console.log(this.DocData)
    }

    onDoRadioClick() {

        if (this.hasEvent) {

            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = this.DocData;
            DOMessage.njDocDefTemplate = this.DocDefTemplate;

            let lstFindLookupType = this.lstDocDefTemplateLookup
            DOMessage.lstDocDefTemplateLookup = lstFindLookupType;

            this.clickRadio.emit(DOMessage);
        }
    }
    ignoreLabel(lookup: NJReadDocDefTemplateLookup): boolean {
        if (this.ignorLabel || lookup.longDesc.length <= 0)
            return true;
        if (this.customParameters['HideLabel'] == null) {
            return false;
        } else {
            return true;
        }
    }
    ignoreLabel2(lookup: NJReadDocDefTemplateLookup): boolean {
        if (this.ignoreLabel(lookup) == false)  // would never want both labels to show.
            return true;

        if (this.ignorLabel || lookup.longDesc2.length <= 0)
            return true;
        if (this.customParameters['HideLabel'] == null) {
            return false;
        } else {
            return true;
        }
    }
}
